import { render, staticRenderFns } from "./VueBootstrapTypeaheadList.vue?vue&type=template&id=25372712"
import script from "./VueBootstrapTypeaheadList.vue?vue&type=script&lang=js"
export * from "./VueBootstrapTypeaheadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports